import { render, staticRenderFns } from "./interview.vue?vue&type=template&id=0edf8c72&"
import script from "./interview.vue?vue&type=script&lang=js&"
export * from "./interview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports